require('./userNotificationsSection.scss');

//@vendor
const React = require('react');
const PropTypes = require('prop-types');
//@components
const UserNotificationsSectionFilter = require('components/userNotifications/userNotificationsSection/userNotificationsSectionFilter/userNotificationsSectionFilter');
const UserNotificationsSectionContent = require('components/userNotifications/userNotificationsSection/userNotificationsSectionContent/userNotificationsSectionContent');

// @utilities
const { recordLink } = require("utilities/tagging");

// @constants
const {
    NOTIFICATIONS_FILTER,
    NOTIFICATIONS_INIT,
} = require("constants/tagging.js");

class UserNotificationsSection extends React.Component {
    constructor (props) {
        super(props);

        this.state = {
            filterSettingsOpen: false
        }

        this.clearFilters = this.clearFilters.bind(this);
        this.setFilters = this.setFilters.bind(this);
        this.handleToggleFilters = this.handleToggleFilters.bind(this);
        this.resetFilter = this.resetFilter.bind(this);
    }

    componentWillUnmount() {
        this.props.clearFilters();
    }

    clearFilters() {
        const { clearFilters, requestUserNotifications } = this.props;

        clearFilters();
        requestUserNotifications();
    }

    resetFilter(filter) {
        const { requestUserNotifications, resetFilter } = this.props;

        resetFilter(filter);
        requestUserNotifications();
    }

    setFilters(filters) {
        const { requestUserNotifications, setNotificationsFilters } = this.props;
        this.handleToggleFilters(); //close filters window, then apply filters
        setNotificationsFilters(filters);
        requestUserNotifications();
    }

    handleToggleFilters() {
        this.setState({
            filterSettingsOpen: !this.state.filterSettingsOpen
        });

        recordLink(NOTIFICATIONS_FILTER, NOTIFICATIONS_INIT);
    }

    render () {
        const {
            flagBasedFeatures,
            getChoreDetail,
            immCards,
            immFilters,
            immUserNotifications,
            openYoungCardChores,
            requestNextUserNotificationsPage,
            requestUserNotifications,
            getMoneyRequestDetails,
            moneySavingsRequestDetails,
        } = this.props;

        return (
            <div className="user-notifications-section">
                <UserNotificationsSectionFilter
                    setFilters={this.setFilters}
                    onCloseClick={this.handleToggleFilters}
                    immFilters={immFilters}
                    isOpen={this.state.filterSettingsOpen}
                />
                <UserNotificationsSectionContent
                    flagBasedFeatures={flagBasedFeatures}
                    getChoreDetail={getChoreDetail}
                    clearFilters={this.clearFilters}
                    immCards={immCards}
                    immFilters={immFilters}
                    openYoungCardChores={openYoungCardChores}
                    onRetry={requestUserNotifications}
                    onFilterClick={this.handleToggleFilters}
                    requestNextUserNotificationsPage={requestNextUserNotificationsPage}
                    resetFilter={this.resetFilter}
                    immUserNotifications={immUserNotifications}
                    requestUserNotifications={requestUserNotifications}
                    getMoneyRequestDetails={getMoneyRequestDetails}
                    moneySavingsRequestDetails={moneySavingsRequestDetails}
                />
            </div>
        );
    }
}

UserNotificationsSection.propTypes = {
    clearFilters: PropTypes.func.isRequired,
    flagBasedFeatures: PropTypes.object,
    getChoreDetail: PropTypes.func.isRequired,
    getMoneyRequestDetails: PropTypes.func.isRequired,
    immCards: PropTypes.object.isRequired,
    immFilters: PropTypes.object.isRequired,
    immUserNotifications: PropTypes.object.isRequired,
    openYoungCardChores: PropTypes.object.isRequired,
    requestNextUserNotificationsPage: PropTypes.func.isRequired,
    requestUserNotifications: PropTypes.func.isRequired,
    resetFilter: PropTypes.func.isRequired,
    setNotificationsFilters: PropTypes.func.isRequired,
    moneySavingsRequestDetails: PropTypes.func.isRequired
}

module.exports = UserNotificationsSection;
